import apiRequest from 'utils/api/apiRequest';
import * as URLS from './urls';

export const paymentBehaviorApi = {
  sharing: () => apiRequest(URLS.IS_SHARING),
  loadExclusionList: () => apiRequest(URLS.EXCLUSIONS),
  addToExclusionList: data => {
    const options = {
      method: 'POST',
      data,
      formaData: true,
      fieldName: 'payorRegnos'
    };
    return apiRequest(URLS.ADD_EXCLUSIONS, options);
  },
  removeExclusion: ssn => {
    return apiRequest(`${URLS.REMOVE_EXCLUSION}/${ssn}`, { method: 'delete' });
  }
};
